/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */
import * as References from './ReviewsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#generateTitle
 */
export const GENERATE_TITLE_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_generateTitle';
export const GENERATE_TITLE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GENERATE_TITLE_QUERY_FIELD_NAME,
  args: ['type', 'entityName', 'answers', 'ratings'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.generateTitleRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getSummary
 */
export const GET_SUMMARY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getSummary';
export const GET_SUMMARY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUMMARY_QUERY_FIELD_NAME,
  args: ['entityId', 'type', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getEditability
 */
export const GET_EDITABILITY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getEditability';
export const GET_EDITABILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_EDITABILITY_QUERY_FIELD_NAME,
  args: ['reviewId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getEditabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getThemes
 */
export const GET_THEMES_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getThemes';
export const GET_THEMES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_THEMES_QUERY_FIELD_NAME,
  args: ['entityId', 'type', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getThemesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#searchReviews
 */
export const SEARCH_REVIEWS_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_searchReviews';
export const SEARCH_REVIEWS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_REVIEWS_QUERY_FIELD_NAME,
  args: ['search', 'language', 'sortFields', 'entityId', 'reviewTypes', 'reviewTypesEnums', 'overallRating', 'reviewerPortalId', 'reviewerUserId', 'employeeSizes', 'industries', 'tagFilters', 'limit', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.searchReviewsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#searchReviewsLegacy
 */
export const SEARCH_REVIEWS_LEGACY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_searchReviewsLegacy';
export const SEARCH_REVIEWS_LEGACY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_REVIEWS_LEGACY_QUERY_FIELD_NAME,
  args: ['search', 'language', 'sortFields', 'entityId', 'reviewTypes', 'reviewTypesEnums', 'overallRating', 'reviewerPortalId', 'reviewerUserId', 'employeeSizes', 'industries', 'tagFilters', 'limit', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.searchReviewsLegacyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#checkReviewability
 */
export const CHECK_REVIEWABILITY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_checkReviewability';
export const CHECK_REVIEWABILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CHECK_REVIEWABILITY_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewType'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.checkReviewabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getOverallStats
 */
export const GET_OVERALL_STATS_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getOverallStats';
export const GET_OVERALL_STATS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OVERALL_STATS_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewType'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getOverallStatsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getOverallStatsBatch
 */
export const GET_OVERALL_STATS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getOverallStatsBatch';
export const GET_OVERALL_STATS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OVERALL_STATS_BATCH_QUERY_FIELD_NAME,
  args: ['entityIds', 'reviewTypeName', 'reviewType', 'createdAfter'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getOverallStatsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewStats
 */
export const GET_REVIEW_STATS_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getReviewStats';
export const GET_REVIEW_STATS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_REVIEW_STATS_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewType'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getReviewStatsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewStatsBatch
 */
export const GET_REVIEW_STATS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getReviewStatsBatch';
export const GET_REVIEW_STATS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_REVIEW_STATS_BATCH_QUERY_FIELD_NAME,
  args: ['entityIds', 'reviewType'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getReviewStatsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getPrivateFeedback
 */
export const GET_PRIVATE_FEEDBACK_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getPrivateFeedback';
export const GET_PRIVATE_FEEDBACK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRIVATE_FEEDBACK_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewType', 'limit', 'offset', 'sort'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getPrivateFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewRequestEmailTokens
 */
export const GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getReviewRequestEmailTokens';
export const GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.getReviewRequestEmailTokensRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#previewReviewRequestEmail
 */
export const PREVIEW_REVIEW_REQUEST_EMAIL_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_previewReviewRequestEmail';
export const PREVIEW_REVIEW_REQUEST_EMAIL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: PREVIEW_REVIEW_REQUEST_EMAIL_QUERY_FIELD_NAME,
  args: ['listingId', 'userId', 'content'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.previewReviewRequestEmailRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewTags
 */
export const GET_REVIEW_TAGS_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getReviewTags';
export const GET_REVIEW_TAGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_REVIEW_TAGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getReviewTagsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getReviewerDisplayName
 */
export const GET_REVIEWER_DISPLAY_NAME_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getReviewerDisplayName';
export const GET_REVIEWER_DISPLAY_NAME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_REVIEWER_DISPLAY_NAME_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.getReviewerDisplayNameRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getOwnReviewsByAppIds
 */
export const GET_OWN_REVIEWS_BY_APP_IDS_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getOwnReviewsByAppIds';
export const GET_OWN_REVIEWS_BY_APP_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OWN_REVIEWS_BY_APP_IDS_QUERY_FIELD_NAME,
  args: ['appIds'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.getOwnReviewsByAppIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});